import { render, staticRenderFns } from "./PrestationUntyped.vue?vue&type=template&id=b73d9290&scoped=true"
import script from "./PrestationUntyped.vue?vue&type=script&lang=js"
export * from "./PrestationUntyped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73d9290",
  null
  
)

export default component.exports